import { useUpdateInsightsTimeframe, useUserInsights } from 'features/user';
import React from 'react';
import { InsightsTimeframeSelection } from 'shared/components/ui/insights-timeframe-selection';
import { InsightsTimeframes } from 'shared/types/insights';

export type PeriodSelectionProps = {
  isFullWidth?: boolean;
};

export const PeriodSelection: React.FC<PeriodSelectionProps> = ({
  isFullWidth,
}) => {
  const userInsights = useUserInsights();
  const setInsightsTimeframe = useUpdateInsightsTimeframe();

  return (
    <InsightsTimeframeSelection
      value={userInsights?.timeframe ?? InsightsTimeframes.Year}
      onChange={setInsightsTimeframe}
      isFullWidth={isFullWidth}
      preventDrag
    />
  );
};
